import { useViewport } from '@xyflow/react'
import { useDeferredValue } from 'react'

export default function useZoomLevel() {
  const { zoom } = useViewport()
  return useDeferredValue(zoom)
}
